import { createSlice } from "@reduxjs/toolkit";

const agentChatState = createSlice({
  name: "agentChatState",
  // open: 최상단(Navbar) 버튼이 토글하는 챗 열림 상태. **이 슬라이스에는 이것만 둔다.**
  //   챗 패널 인스턴스는 앱 셸(AgentChatHost)에 하나뿐이고 화면 이동으로 언마운트되지 않으므로,
  //   대화를 redux 에 저장했다 복원하던 스냅샷(snapshot)과 중복 렌더 방지용 ref-count
  //   (functionalCount)는 존재 이유가 사라져 제거했다(2026-08-10).
  //   대화는 패널 state 로만 산다 — 새로고침하면 새 대화로 시작하고(의도), 지난 대화는 사용자가
  //   기록 버튼에서 고른다. 이 슬라이스를 persist 대상에 넣지 말 것: 새로고침을 넘어 살아남는
  //   저장은 "앱 로드 = 새 대화"라는 세션 경계를 깨뜨린다.
  initialState: { open: false },
  reducers: {
    toggleAgentChat: (state) => { state.open = !state.open; },
    setAgentChatOpen: (state, action) => { state.open = action.payload; },
  },
});

export const { toggleAgentChat, setAgentChatOpen } = agentChatState.actions;
export const getAgentChatOpen = (state) => state.agentChatState.open;
export default agentChatState.reducer;
